import React from 'react'
import { SplitButton } from 'primereact/splitbutton'
import PropTypes from 'prop-types'
import styles from '../../../css/modals/Modal.module.css'
import { useTranslation } from 'react-i18next'
export default function ActionOptionsMenuBlockCases ({ trackingId, actionTracking, options: { trackingOptionMenu, denunciationOptionMenu }, actionDenunciation }) {
  const { t } = useTranslation('dataTableDemo')
  const items = []

  if (trackingOptionMenu) {
    items.push({
      label: t('menuBlockCases.label1'),
      icon: 'fas fa-file-alt',
      disabled: trackingId === null,
      command: () => {
        actionTracking()
      }
    })
  }
  if (denunciationOptionMenu) {
    items.push({
      label: t('menuBlockCases.label2'),
      icon: 'fas fa-file-alt',
      command: () => {
        actionDenunciation()
      }
    })
  }

  return (
    <>
      <SplitButton dropdownIcon="pi pi-ellipsis-v" model={items} menuClassName={styles.menuBlockCases}/>
    </>
  )
}

ActionOptionsMenuBlockCases.propTypes = {
  trackingId: PropTypes.number,
  options: PropTypes.object,
  actionTracking: PropTypes.func,
  actionDenunciation: PropTypes.func
}
